import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

const getActionTakenLabel = (actionTaken) => {
  const normalizedAction = String(actionTaken || "").trim();
  return normalizedAction || "Pending";
};

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  const [grievances, setGrievances] = useState([]);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    const orgId = localStorage.getItem("orgId");
    const branchId = localStorage.getItem("branchId");

    if (!userId || !orgId || !branchId) {
      console.error("Missing required parameters.");
      return;
    }

    const apiUrl = `${ApiUrl.apiurl}Grievance/listByStudent/?student_id=${userId}&org_id=${orgId}&branch_id=${branchId}`;

    const fetchData = async () => {
      try {
        const response = await fetch(apiUrl);
        const result = await response.json();
        setGrievances(result.data || []);
      } catch (error) {
        console.error("Error fetching grievances:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT GRIEVANCES
              </p>

              {/* Buttons Row */}
              <div className="row mb-3 mt-2">
                <div className="col-12 d-flex justify-content-start gap-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/student/new-grievance")}
                  >
                    New Grievance
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/student/dashboards")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* Grievance Table */}
              <div className="row mt-2">
                <div className="col-12">
                  <Col>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead className="table-primary text-center">
                          <tr>
                            <th>Sr.No</th>
                            <th>Grievance Number</th>
                            <th>Type</th>
                            <th>Priority</th>
                            <th>Severity</th>
                            <th>Grievance</th>
                            <th>Action Taken</th>
                            <th>Action Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {grievances.length > 0 ? (
                            grievances.map((item, index) => (
                              <tr key={item.grievance_number || index}>
                                <td>{index + 1}</td>
                                <td>{item.GrievanceNumber}</td>
                                <td>{item.GrievanceType}</td>
                                <td>{item.GrievancePriority}</td>
                                <td>{item.GrievanceSeverity}</td>
                                <td>{item.details}</td>
                                <td>{getActionTakenLabel(item.ActionTaken)}</td>
                                <td>{item.ActionTakenDateTime || "-"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No grievances found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
